import { CSQuery } from './CSQuery';
import type { CSQueryPayload } from '../types/CSQueryPayload';

interface CSWidgetQueryPayload extends CSQueryPayload {
    fetchCounts: boolean;
    fetchGraph: boolean;
}

abstract class CSWidgetQuery extends CSQuery {
    private fetchCounts: boolean = true;
    private fetchGraph: boolean = true;

    setFetchCounts(fetchCounts: boolean): this {
        this.fetchCounts = fetchCounts;
        return this;
    }

    setFetchGraph(fetchGraph: boolean): this {
        this.fetchGraph = fetchGraph;
        return this;
    }

    // Override build to include additional fields.
    build(): CSWidgetQueryPayload {
        return {
            ...super.build(),
            fetchCounts: this.fetchCounts,
            fetchGraph: this.fetchGraph,
        };
    }
}

export type { CSWidgetQueryPayload };
export { CSWidgetQuery };
